import styled from 'styled-components';

export const Container = styled.main`
  background-color: #fff;
  padding: 16px;
  .correctional-judgement {
    display: flex;
    align-items: center;
    margin-top: 16px;
    padding: 16px;
    background-color: #f4f4f4;
    border-radius: 4px;
    min-height: 150px;
  }

  .judgement-on-merits-document {
    padding: 10px;
    background-color: #f4f4f4;
    border-radius: 4px;
  }
  .condamnation-field {
    margin-right: 50px;
    width: 800px;
  }
  .judgement-on-merits-info {
    margin-left: 30px;
    margin-right: 30px;
  }
  .judgement-on-merits-info-conclusion {
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 20px;
  }
  .judgement-on-merits-doc-info {
    margin-top: 50px;
  }
  .judgement-on-merits-doc-info-wrapper {
    display: flex;
    flex-direction: row;
  }
  .expertise {
    background-color: white;
    margin-bottom: 16px;
    padding: 16px;
    border-radius: 4px;
    min-height: 50px;
  }
  .text-field-amount {
    display: inline;
  }
  .calculated-amount {
    width: 20%;
    padding-right: 10px;
  }
  .expertise-title {
    margin-bottom: 30px;
  }
  .victims {
    display: flex;
    margin-bottom: 32px;
    font-size: bold;
  }
  .victim-item {
    background-color: #fff;
    box-shadow: 0px 1px 3px #000000;
    border-radius: 4px;
    height: 36px;
    color: #2b2727;
    font-size: 13px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    padding: 10px 16px;
    width: 200px;
    margin-top: 10px;
    margin-right: 16px;
    align-self: center;
  }
  .victim-info {
    width: 100%;
    display: flex;
    flex-direction: row;
    height: auto;
    left: 16px;
    top: 16px;
    margin-bottom: 10px;
    background: #ffffff;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
  }
  .victim-info-item {
    height: auto;
    left: 0px;
    top: 4px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    padding: 13px 20px;
    color: #666666;
  }
  .victim-info-sub-item {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 25px;
    color: #2b2727;
    text-transform: uppercase;
  }
  .deceased-victim {
    height: 15px;
    left: 0px;
    top: 4px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 25px;
    color: #666666;
    margin: 30px 5px;
  }

  .add-beneficiary-btn {
    margin-left: auto;
    margin-top: 20px;
  }
  .error {
    color: red;
  }
  .validation-error {
    display: flex;
    flex-direction: column;
  }
  .submit-form {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  .cancel_button {
    margin-right: 5px;
  }
  .civil-judgement {
    display: flex;
    align-items: center;
    min-height: 80px;
  }
  .judgement-add-doc {
    display: flex;
    align-items: center;
    display: block;
    margin-top: 16px;
    padding: 16px;
    background-color: #f4f4f4;
    border-radius: 4px;
  }
  .add-judgement-civil {
    padding: 10px 16px;
  }
  .add-sued-party {
    padding: 10px 16px;
    margin-top: 20px;
  }
  .judgement-on-merits-title {
    font-size: 18px;
    font-weight: bold;
    color: #2b2727;
    margin-top: 16px;
  }
  .judgement-add-doc-title {
    font-size: 18px;
    font-weight: bold;
    color: #2b2727;
    margin-bottom: 16px;
    margin-top: 10px;
  }
  .MuiInputLabel-root {
    font-size: 13px;
  }
  .upload-document {
    font-weight: bold;
    width: 50%;
  }

  .upload-document-button {
    font-weight: normal;
    font-size: 14px;
    min-width: 220px;
  }
  .shared-responsability {
    margin-bottom: 16px;
    margin-top: 16px;
  }
  .shared-responsability-field {
    width: 200px;
  }
  .alert {
    color: red;
  }
  .judgement-on-merits-contestation-container {
    padding: 8px;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .contestation-status,
  .contestation-reason {
    padding: 8px 0;
    font-size: 14px;
    color: #2b2727;
  }
  .contestation-status > *,
  .contestation-reason > * {
    margin-right: 16px;
  }

  .contestation-sub-bloc-title {
    font-weight: bold;
  }
  .contestation-container-title {
    font-weight: bold;
    font-size: 14px;
    color: #0072c6;
    text-transform: uppercase;
    padding: 5px 0;
  }
  .sued-party-recap {
    width: 100%;
  }
  .condamnation-textfield {
    margin-right: 50px;
  }
  .document-wrapper {
    margin-left: 30px;
  }
  .deceased-victims {
    align-items: center;
    margin-top: 10px;
    padding: 16px;
    background-color: #f4f4f4;
    border-radius: 4px;
    min-height: 150px;
  }
  .formEl {
    width: 100px;
    margin-right: 30px;
  }
  .beneficiary-content {
    width: 100%;
    border-radius: 4px;
    box-shadow: 0px 1px 3px #0000001f;
    padding: 16px;
    display: block;
  }
  .accordion-content {
    margin-bottom: 12px;
    margin-top: 20px;
  }
  .input-fields {
    width: 300px;
  }
  .input-fields-1 {
    width: 200px;
  }
  .info-item {
    height: 15px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    color: #00000061;
  }
  .info-sub-item {
    width: 88px;
    height: 15px;
    left: 0px;
    top: 0px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 15px;
    color: #0880bc;
    margin-top: 5px;
  }
  .display-decision {
    justify-content: space-between;
  }
  .other-item {
    align-self: end;
  }
  .add-recap-bloc {
    background-color: #ffffff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    padding: 24px;
    display: grid;
  }
  .add-recap-bloc-title {
    color: #2b2727;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 24px;
  }
`;

export const JudgementCivilContainer = styled.div`
  .upload-document {
    font-weight: bold;
    margin: 0px;
    width: 50%;
  }
  .responsability-share {
    margin-bottom: 20px;
  }
  .caduc-item {
    background-color: #fff;
    box-shadow: 1px 1px 3px #d60e0e;
    border-radius: 4px;
    color: #c30b0b;
    font-size: 17px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    padding: 16px 16px;
    margin-right: 16px;
    width: 100px;
  }
  .caduc-position {
    align-self: center;
  }
`;
